import React from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

const CouponEditSkeleton = () => {
  const { t } = useLocoTranslation()
  return (
    <div className={`flex flex-col gap-5`}>
      <div className={`flex flex-col overflow-x-hidden rounded-lg `}>
        <div className={`bg-brand-primary-subtle text-text-primary flex gap-1 px-6 py-4 font-bold`}>
          <span>{`${t('dashboard.coupon.code')}:`}</span>
          <div className="bg-skeleton-primary max-w-[100px] flex-auto animate-pulse rounded-sm text-transparent">
            .
          </div>
        </div>
        <div
          className={`bg-background-secondary flex animate-pulse flex-col flex-wrap gap-5 p-6 lg:flex-row`}
        >
          <div className="bg-skeleton-primary flex-auto rounded-sm py-3 text-transparent">.</div>
          <div className="bg-skeleton-primary flex-inherit min-w-[300px] rounded-sm py-3 text-transparent">
            .
          </div>
          <div className="bg-skeleton-primary flex-inherit min-w-[300px] rounded-sm py-3 text-transparent">
            .
          </div>
        </div>
      </div>
    </div>
  )
}

export default CouponEditSkeleton
